import React, {useEffect, useState} from 'react';
import {Card} from "react-bootstrap-v5";
import OverlayLoadingOrError from "../../../components/overlay-component/overlay-loading-or-error";
import {lotService} from "../../../services/lot-service";
import T from "i18n-react";
import BubbleChart from "../../../components/charts/bubble-chart";

const CardIndicatorsLotsClosedNbAnalysis = ({className}) => {
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;

    const [state, setState] = useState({isLoading: false, error: ''});

    const [currentYearNb, setCurrentYearNb] = useState(0);
    const [lastYearNb, setLastYearNb] = useState(0);

    useEffect(() => {
        const getIndicators = async () => {
            try {
                setState({isLoading: true, error: ''});
                const indicators = await lotService.indicatorsLotsClosedNbAnalysis();
                setCurrentYearNb(indicators.currentYear.numberOfAnalyses);
                setLastYearNb(indicators.lastYear.numberOfAnalyses);
                setState({isLoading: false, error: ''});
            } catch (error) {
                setState({isLoading: false, error: error.message})
            }
        }

        getIndicators();
    }, []);

    return (
        <Card className={`card-indicators h-100 ${className}`}>
            <Card.Header className="d-flex justify-content-between align-items-end pb-0">
                <Card.Title>{T.translate(`indicators.lotsClosedNbAnalysis`)}</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="w-50 mx-auto pb-2 px-3">
                    <BubbleChart
                        dataset={[
                            {x: lastYear, y: lastYearNb},
                            {x: currentYear, y: currentYearNb},
                        ]}
                    />
                </div>
                <OverlayLoadingOrError isLoading={state.isLoading} error={state.error} onCloseError={() => setState({isLoading: false, error: ''})}/>
            </Card.Body>
        </Card>
    );
}

export default CardIndicatorsLotsClosedNbAnalysis;